import React from 'react'
import PageContent from 'components/common/PageContent'
import ConnectorsTable from 'components/organisation/connectors/ConnectorsTable'

export default function Connectors() {

    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Organisation", url: "/organisation"},
        {id: 2, title: "Connectors"}
    ];

    return (
        <PageContent pathElements={pathElements}>
            <ConnectorsTable/>
        </PageContent>
    )
}
